import React from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import './card-container-separator.css';
function CardContainerSeparator() {
    return (React.createElement("div", { className: "c-card-container-separator" }));
}
const awesomeProps = {
    type: ComponentType.LAYOUT,
};
AwesomeComponent(awesomeProps)(CardContainerSeparator);
export { CardContainerSeparator, };
//# sourceMappingURL=card-container-separator.js.map